import React from 'react';


export default class TreinosPlanilhas extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Os níveis são totalmente individuais, já que cada pessoa é única, e a EXECUÇÃO do treino vai definir isso. </strong><br /><br />
      Os níveis são totalmente individuais, já que cada pessoa é única, e a EXECUÇÃO do treino vai definir isso.<br />

      A nomenclatura: adaptação/inicial/intermediária/avançada é clássica e muito usada no desporto (esporte/atividade física) e sua origem está relacionada à preparação competitive. Ou seja, se você está se preparando para competir daqui a um ano, NÃO IMPORTA se você já treina há 10 anos... ainda assim estará na fase de ADAPTAÇÃO novamente. No caso dos treinos de musculação na maioria dos casos, e principalmente no caso do Foco90, ninguém está se preparando num calendário competitive, e não tem como objetivo:<br />
      * aumentar potência<br />
      * aumentar força estática<br />
      * aumentar arranque<br />
      * aumentar força explosiva<br /><br />

      Todas vocês estão atrás de 4 coisas basicamente:<br />
      * redução da gordura corporal<br />
      * ganho de massa muscular<br />
      * definição muscular (que é a soma dos 2 itens acima).<br />
      * saúde<br />
      Então, percebendo isso por quase 20 anos, comecei a pesquisar em "como desenvolver uma Metodologia que desse o melhor resultado de hipertrofia, emagrecimento e definição".<br />
      NÃO EXISTE RELAÇÃO entre exercício para iniciantes e exercícios para avançado, por exemplo.<br /><br />
      É comum ver professores usando essas terminologias inadequadamente... mais ou menos assim:<br />
      ERRADO DEMAIS, MAS muito comum:<br />
      Extensora e leg press é para iniciante<br />
      Agachamento e Stiff é para intermediário e avançado<br />
      Agachamento com Drop set é para avançado<br />
      Agachamento + Stiff SuperSet é para Deuses kkkk<br />

      Dá até gastura de escrever essas tolices. Mas vocês ouviram isso a vida toda.<br /><br />
    Então, criei a Metodologia Totalmente adaptável em vários aspectos. <strong>Os níveis são totalmente individuais, já que cada pessoa é única, e a EXECUÇÃO do treino vai definir isso. As carcterísticas individuais, a consciência corporal, o ajuste de carga, a flexibilidade, a experiência de treino. Isso é o que vai tornar o treino individual, e não a estrutura de exercícios.</strong><br /><br />

      * Você pode estar em qualquer nível de condicionamento ou experiência com a musculação.<br />
      * Você NÃO precisa respeitar a ORDEM dos exercícios de sua planilha. Assim, quando uma máquina estiver ocupada, poderá usar qualquer outra da planilha do dia.<br />
      * Você sempre vai treinar 2 vezes por semana cada músculo, quer você escolha treinar 3, 4, 5 ou 6 dias na semana... (isso se chama coesão).


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/TreinosPlanilhas.js